import { useReactiveVar } from '@apollo/client/react';
import { VisitorGroup } from 'graphql/generated/graphqlTypes';
import { Translation } from 'hooks/useTranslation/useTranslation';
import { isEqual, orderBy } from 'lodash';
import { useEffect, useState } from 'react';
import { setPermissionsGroups } from 'state/actions/permissions';
import { PermissionsState } from 'state/types';
import { permissionsVar } from 'state/vars';

interface Sorting {
  isAscending?: boolean;
  columnName?: string;
}

export const handleSorting = (translation: Translation, item: VisitorGroup, columnName?: string) => {
  switch (columnName) {
    case translation.ad_groups:
    default:
      return item.name;
  }
};

export const getSortedArray = (externalUsersGroups: PermissionsState, sorting: Sorting, translation: Translation) =>
  orderBy(externalUsersGroups, (item) => handleSorting(translation, item, sorting.columnName), [
    sorting.isAscending ? 'asc' : 'desc'
  ]);

const useSortingPermissionsTable = (translation: Translation) => {
  const permissionGroups = useReactiveVar(permissionsVar);
  const [sorting, setSorting] = useState<Sorting>({ isAscending: true, columnName: translation.ad_groups });

  const handleSortingOnClick = (columnName: string) => {
    if (sorting.isAscending !== undefined && sorting.columnName === columnName) {
      return setSorting({ isAscending: !sorting.isAscending, columnName });
    }
    return setSorting({ isAscending: true, columnName });
  };

  const handleSortingIcon = (columnName: string) => {
    if (sorting.isAscending !== undefined)
      if (sorting.columnName === columnName) return sorting.isAscending ? 'ArrowUpSorting' : 'ArrowDownSorting';
    return undefined;
  };

  useEffect(() => {
    const sortedPermissionGroups = getSortedArray(permissionGroups, sorting, translation);
    if (!isEqual(sortedPermissionGroups, permissionGroups)) setPermissionsGroups(sortedPermissionGroups);
  }, [permissionGroups, sorting, translation]);

  return { handleSortingOnClick, handleSortingIcon };
};

export default useSortingPermissionsTable;
